import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { useInvoiceOverview } from "./InvoiceOverviewContext";
import { formatCurrency } from "utils/currency";

const LineItemsTab = () => {
  const { invoice } = useInvoiceOverview();
  const items = invoice?.items ?? [];

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <h6 className="mb-3 text-uppercase text-muted">Line items</h6>
            {items.length > 0 ? (
              <div className="table-responsive table-card">
                <Table className="align-middle table-nowrap mb-0">
                  <thead className="table-light text-muted small">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Description</th>
                      <th scope="col" className="text-end">
                        Qty
                      </th>
                      <th scope="col" className="text-end">
                        Unit price
                      </th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, i) => (
                      <tr key={item.id ?? i}>
                        <td className="text-muted">{i + 1}</td>
                        <td className="fw-medium">{item.description}</td>
                        <td className="text-end tabular-nums">
                          x{item.quantity}
                        </td>
                        <td className="text-end tabular-nums">
                          {formatCurrency(item.unitPrice)}
                        </td>
                        <td className="text-end tabular-nums fw-medium">
                          {formatCurrency(item.baseAmount)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="table-active">
                      <th colSpan={4} className="text-end">
                        Payable amount
                      </th>
                      <td className="text-end fw-semibold tabular-nums">
                        {formatCurrency(invoice?.baseAmount)}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            ) : (
              <p className="text-muted mb-0">No line items on this invoice.</p>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default LineItemsTab;
